import { GzChipItemWebComponent } from './component/GzChipItemWebComponent';
import { WEB_COMPONENT_GZ_CHIPS_ITEM, WEB_COMPONENT_GZ_CHIPS_GROUP } from '../../webcomponents.constants';
import { GzChipsGroupWebComponent } from './component/GzChipsGroupWebComponent';

export { GzChipItemWebComponent, GzChipsGroupWebComponent };

window.customElements.define(WEB_COMPONENT_GZ_CHIPS_ITEM, GzChipItemWebComponent);
window.customElements.define(WEB_COMPONENT_GZ_CHIPS_GROUP, GzChipsGroupWebComponent);
